<script>
  import { onMount, onDestroy } from "svelte";
  import { createGuidesStore } from "./Knock/guides";
  import Card from "./Knock/Card.svelte";

  // svelte-ignore unused-export-let
  export let live;
  export let public_key;
  export let signed_key;
  export let guide_channel_id;
  export let user_id;

  const guides = createGuidesStore();

  function onNavigate({ detail: { href } }) {
    const url = /^https?:\/\//.test(href) ? href : window.location.origin + href;
    guides.navigate(url);
  }

  // Render one card at a time (highest priority) so fixed-position cards don't
  // stack. Knock's ordering/throttling controls which one wins.
  $: cardGuide = $guides.guides.find((g) => g.type === "card");

  onMount(async () => {
    await guides.init({ public_key, signed_key, user_id, guide_channel_id });
    window.addEventListener("phx:navigate", onNavigate);
  });

  onDestroy(() => {
    window.removeEventListener("phx:navigate", onNavigate);
    guides.cleanup();
  });
</script>

{#if cardGuide}
  <Card
    guide={cardGuide}
    on:seen={() => guides.markSeen(cardGuide)}
    on:interacted={(e) => guides.markInteracted(cardGuide, e.detail)}
    on:archived={() => guides.markArchived(cardGuide)}
  />
{/if}
